<div class="wrapper" *ngIf="mpModal"
  [class.from-bottom-mode]="mpMode === 'from-bottom'">
  <div class="backdrop" [class.hidden]="!mpModalBackdrop && !mpClickableModalBackdrop"
    [class.invisible]="mpClickableModalBackdrop && !mpModalBackdrop"
    (click)="backdropClicked()"></div>
  <div #modal class="modal" cdkTrapFocus
    [class.sidenav-mode]="mpMode === 'sidenav'"
    [class.sidenav-animate-in]="mpMode === 'sidenav'"
    [class.floating-mode]="mpMode === 'floating'"
    [class.from-bottom-mode]="mpMode === 'from-bottom'"
    [class.centered]="mpMode === 'centered'">
    <div class="header" *ngIf="mpDisplayHeader && (mpModalTitle || (mpClosable && mpShowCloseButton))">
      <div *ngIf="mpModalTitle" class="title">{{ mpModalTitle }}</div>
      <app-mp-button
        class="close-button"
        *ngIf="mpClosable && mpShowCloseButton"
        (click)="closeModal()"
        size="icon-medium"
        color="negative"
        faIcon="fas fa-times">
      </app-mp-button>
    </div>
    <div [class.content]="mpMode !== 'floating'">
      <ng-container
        *ngTemplateOutlet="mpModal, injector: projectedInjector; context: {mpModalData: mpModalData}"></ng-container>
    </div>
    <div class="footer" [class.footer-top-border]="mpDisplayFooterTopBorder" *ngIf="mpDisplayFooter">
      <app-mp-button
        *ngIf="mpShowCancelButton"
        size="medium"
        [label]="mpModalCancelLabel | translate"
        color="negative"
        (buttonClicked)="closeModal()">
      </app-mp-button>
      <app-mp-button
        [disabled]="(mpModalService.saveButtonState$ | async) === false || (mpModalService._saveButtonLoading$ | async) === true"
        [isLoading]="(mpModalService._saveButtonLoading$ | async) === true"
        [label]="mpModalSaveLabel | translate"
        (click)="save()"
        size="medium">
      </app-mp-button>
    </div>
  </div>
</div>
